
import { defineComponent, onBeforeMount, reactive } from 'vue';
import { Modal } from 'ant-design-vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import Icone from '@/core/components/Icone.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { IBuscaAvancada } from '@/core/models/BuscaAvancada/IBuscaAvancada';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { EVinculoEmpresa } from '@/core/models/Enumeradores/EEVinculoEmpresa';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import storeSistema from '@/store/storeSistema';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { ICardKanban, ICardKanbanDetalhe, IColunaKanban } from '@/core/models/IKanban';
import Kanban from '@/core/components/Kanban/Kanban.vue';
import SelecionarFiltroPeriodoMovimentoComercial from '@/components/Compartilhados/SelecionarFiltroPeriodoMovimentoComercial.vue';
import { IOrdenacaoRegistro } from '@/core/models/IOrdenacaoRegistro';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IParametrosConsultaRecebimentoMercadoria } from '@/models/ParametrosRequisicao/Compras/IParametrosConsultaRecebimentoMercadoria';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import Card from '@/core/components/Tela/Card.vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import BuscaGeral from '@/core/components/BuscaAvancada/BuscaGeral.vue';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import PedidoCompraModal from './PedidoCompraModal.vue';
import { IDTOPedidoCompra } from '@/models/DTO/Compras/IDTOPedidoCompra';
import ServicoPedidoCompra from '@/servicos/Compras/ServicoPedidoCompras';
import { EStatusPedidoCompra } from '@/models/Enumeradores/Compras/EStatusPedidoCompra';

export default defineComponent({
  name: 'PedidoComprasIndex',
  components: {
    Icone,
    PreviewPdf,
    Card,
    SelecionarDataInicialFinal,
    BuscaGeral,
    Kanban,
    PedidoCompraModal,
    SelecionarFiltroPeriodoMovimentoComercial,
    TituloPadrao,
  },
  setup(props) {
    const servicoPedidoCompra = new ServicoPedidoCompra();
    const {
      telaBase, obterPermissoes, preencherEmpresasDisponiveis,
      defineEmpresasSelecionadasComPermissao, filtrarPermissaoDadosUsuarioMultiEmpresas,
      adicionarAtalho, removerAtalho, apresentarMensagemAlerta, apresentarMensagemErro, apresentarMensagemSucesso,
    } = useTelaBase();
    let debounce = 0;
    const state = reactive({
      identificadorRecurso: 'PEDIDO_COMPRAS',
      identificadorPermissao: 'PER_PEDIDO_COMPRAS',
      empresaSelecionada: 0,
      origemSelecionada: 0,
      dataAtual: '',
      filtroPeriodo: 4,
      dataInicialSelecionada: '',
      dataFinalSelecionada: '',
      buscaRapida: '',
      colunas: [] as IColunaKanban[],
      filtros: [] as IFiltroGenerico[],
      selecionados: [] as number[],
      paginacao: {} as IPagination,
      cardSelecionado: '',
      pedidos: [] as IDTOPedidoCompra[],
      buscaAvancada: {} as IBuscaAvancada,
      exibirLancamento: false,
      operacaoLancamento: {} as ITelaOperacao,
      qtdSelecionados: 0,
      qtdSelecionadosConcluir: 0,
      qtdSelecionadosRetomar: 0,
      qtdSelecionadosCancelar: 0,
      qtdSelecionadosExcluir: 0,
      visualizarKanban: true,
      atualizandoCards: false,
      arquivosPdf: [] as IArquivoPdf[],
    });

    function atualizarQtdSelecionados() {
      state.qtdSelecionados = 0;
      state.qtdSelecionadosConcluir = 0;
      state.qtdSelecionadosCancelar = 0;
      state.qtdSelecionadosExcluir = 0;
      state.qtdSelecionadosRetomar = 0;
      state.colunas.forEach((c) => {
        if (c.qtdSelecionados !== undefined) {
          state.qtdSelecionados += c.qtdSelecionados;
          if (Number(c.identificador) === 1) {
            state.qtdSelecionadosExcluir += c.qtdSelecionados;
          }
          if (Number(c.identificador) < 5) {
            state.qtdSelecionadosConcluir += c.qtdSelecionados;
          }
          if (Number(c.identificador) < 6) {
            state.qtdSelecionadosCancelar += c.qtdSelecionados;
          }
          if (Number(c.identificador) > 1 && Number(c.identificador) < 6) {
            state.qtdSelecionadosRetomar += c.qtdSelecionados;
          }
        }
      });
    }

    function atualizarSelecionadosKanban() {
      state.colunas.forEach((c, index) => {
        state.colunas[index].qtdSelecionados = 0;
      });

      state.pedidos.forEach((r) => {
        const indexColuna = state.colunas.findIndex((c) => c.identificador === String(r.status));
        const indexCard = state.colunas[indexColuna].cards.findIndex((c) => c.identificador === String(r.codigo));
        const indexSelecionados = state.selecionados.findIndex((s) => s === r.codigo);
        if (indexSelecionados >= 0) state.colunas[indexColuna].qtdSelecionados += 1;
        state.colunas[indexColuna].cards[indexCard].selecionado = indexSelecionados >= 0;
      });
      atualizarQtdSelecionados();
    }

    function atualizarSelecionados(identificador: string) {
      atualizarQtdSelecionados();
      const indexSelecionados = state.selecionados.findIndex((s) => s === Number(identificador));
      if (indexSelecionados < 0) {
        state.selecionados.push(Number(identificador));
      } else {
        state.selecionados.splice(indexSelecionados, 1);
      }
    }

    function desmarcarPedidoSelecionado(codigoPedido: number, status: number, statusNovo: number) {
      const indexSelecionados = state.selecionados.findIndex((s) => s === codigoPedido);
      if (indexSelecionados >= 0) {
        let indexColuna = state.colunas.findIndex((c) => c.identificador === String(status));
        let indexCard = state.colunas[indexColuna].cards.findIndex((c) => c.identificador === String(codigoPedido));
        if (indexCard === -1) {
          indexColuna = state.colunas.findIndex((c) => c.identificador === String(statusNovo));
          indexCard = state.colunas[indexColuna].cards.findIndex((c) => c.identificador === String(codigoPedido));
        }
        if (state.colunas[indexColuna].qtdSelecionados > 0) state.colunas[indexColuna].qtdSelecionados -= 1;
        state.colunas[indexColuna].cards[indexCard].selecionado = false;
        state.selecionados.splice(indexSelecionados, 1);
        atualizarQtdSelecionados();
      }
    }

    function preencherColunas() {
      state.colunas = [] as IColunaKanban[];
      state.colunas[0] = {} as IColunaKanban;
      state.colunas[0].identificador = '1';
      state.colunas[0].titulo = 'Em digitação';
      state.colunas[0].cor = '#ff7f50';
      state.colunas[0].cards = [] as ICardKanban[];

      state.colunas[1] = {} as IColunaKanban;
      state.colunas[1].identificador = '2';
      state.colunas[1].titulo = 'Em Análise';
      state.colunas[1].cor = '#daa520';
      state.colunas[1].cards = [] as ICardKanban[];

      state.colunas[2] = {} as IColunaKanban;
      state.colunas[2].identificador = '3';
      state.colunas[2].titulo = 'Confirmado';
      state.colunas[2].cor = '#2e8b57';
      state.colunas[2].cards = [] as ICardKanban[];

      state.colunas[3] = {} as IColunaKanban;
      state.colunas[3].identificador = '4';
      state.colunas[3].titulo = 'Entregue';
      state.colunas[3].cor = '#1843b8';
      state.colunas[3].cards = [] as ICardKanban[];

      state.colunas[4] = {} as IColunaKanban;
      state.colunas[4].identificador = '5';
      state.colunas[4].titulo = 'Cancelados';
      state.colunas[4].cor = '#000000';
      state.colunas[4].cards = [] as ICardKanban[];
    }

    function limparCards() {
      state.colunas.forEach((c, index) => {
        state.colunas[index].qtdSelecionados = 0;
        state.colunas[index].cards = [] as ICardKanban[];
      });
    }

    function criarCard(indexColuna: number, pedido: IDTOPedidoCompra) {
      const card = {} as ICardKanban;
      const indexSelecionados = state.selecionados.findIndex((s) => s === pedido.codigo);

      card.identificadorColuna = state.colunas[indexColuna].identificador;
      card.identificador = String(pedido.codigo);
      card.titulo = `Nº: ${pedido.numeroPedido}`;
      card.ordem = pedido.ordem;
      card.selecionado = indexSelecionados >= 0;
      card.detalhes = [] as ICardKanbanDetalhe[];
      let indexDetalhe = 0;
      card.detalhes[indexDetalhe] = {} as ICardKanbanDetalhe;
      card.detalhes[indexDetalhe].titulo = 'Data de Criação: ';
      card.detalhes[indexDetalhe].detalhe = UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(pedido.dataCriacao);
      indexDetalhe += 1;

      card.detalhes[indexDetalhe] = {} as ICardKanbanDetalhe;
      card.detalhes[indexDetalhe].titulo = 'Fornecedor: ';
      card.detalhes[indexDetalhe].detalhe = pedido.nomeFornecedor.length > 29 ? pedido.nomeFornecedor.substring(0, 30) : pedido.nomeFornecedor;

      indexDetalhe += 1;
      card.detalhes[indexDetalhe] = {} as ICardKanbanDetalhe;
      card.detalhes[indexDetalhe].titulo = 'Total R$: ';
      card.detalhes[indexDetalhe].detalhe = UtilitarioMascara.mascararValor(pedido.totalPedido, 2);

      state.colunas[indexColuna].cards.push(card);
      if (indexSelecionados >= 0) state.colunas[indexColuna].qtdSelecionados += 1;
    }

    function prencheDatasPeriodo() {
      switch (state.filtroPeriodo) {
        case EFiltroPeriodoMovimentoComercial.Hoje:
          state.dataInicialSelecionada = state.dataAtual;
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ontem:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          state.dataFinalSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          break;

        case EFiltroPeriodoMovimentoComercial.SemanaAtual:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 7);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.MesAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaMes(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaMes(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.AnoAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaAno(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaAno(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos15Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 15);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos30Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 30);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos60Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 60);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos90dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 90);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        default:
      }
    }

    async function buscarPedido(ordenacao: IOrdenacao[] = []) {
      state.pedidos = [];
      limparCards();
      state.filtros = [] as IFiltroGenerico[];
      state.buscaAvancada.filtrosAdicionados.forEach((item) => {
        state.filtros.push(item.filtro);
      });

      prencheDatasPeriodo();
      const parametrosConsulta = {} as IParametrosConsultaRecebimentoMercadoria;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.ordenacao = Array<string>();
      parametrosConsulta.periodo = state.filtroPeriodo;
      parametrosConsulta.dataInicial = state.dataInicialSelecionada;
      parametrosConsulta.dataFinal = state.dataFinalSelecionada;
      parametrosConsulta.valorBuscaRapida = state.buscaRapida;
      if (UtilitarioGeral.validaLista(ordenacao) && !state.visualizarKanban) {
        ordenacao.forEach((item) => {
          parametrosConsulta.ordenacao.push(`${item.identificador}|${item.ordem}`);
        });
      } else {
        parametrosConsulta.ordenacao.push('Status', 'Ordem');
      }

      parametrosConsulta.qtdeRegistrosPagina = 1000;

      telaBase.carregando = true;
      const listaPaginada = await servicoPedidoCompra.buscaAvancada(parametrosConsulta, state.filtros);
      state.pedidos = listaPaginada.dados;
      state.pedidos.forEach((r) => {
        criarCard(state.colunas.findIndex((c) => c.identificador === String(r.status)), r);
      });
      telaBase.carregando = false;
    }

    async function atualizarOrdemCards(ordenacaoRegistros: IOrdenacaoRegistro[]) {
      await servicoPedidoCompra.atualizarOrdenacao(ordenacaoRegistros, state.empresaSelecionada);
    }

    function recriarColuna(identificador: string) {
      const index = state.colunas.findIndex((c) => c.identificador === identificador);

      state.colunas[index].cards = [] as ICardKanban[];
      state.colunas[index].qtdSelecionados = 0;
      state.pedidos.forEach((r) => {
        if (r.status === Number(identificador)) {
          criarCard(index, r);
        }
      });
      atualizarQtdSelecionados();
    }

    function obterTituloColuna(identificador: string) {
      const index = state.colunas.findIndex((c) => c.identificador === identificador);
      return state.colunas[index].titulo;
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.empresaSelecionada);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarPedido();
    }

    function selecionarCard(selecionado: string) {
      state.cardSelecionado = selecionado;
    }

    function incluir() {
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Incluir;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = 0;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.exibirLancamento = true;
    }

    function editarPedido(codigoPedido: number) {
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Alterar;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = codigoPedido;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.exibirLancamento = true;
    }

    function clickEditar() {
      editarPedido(Number(state.cardSelecionado));
    }

    async function alterarEtapa(pedido: IDTOPedidoCompra, novaEtapa: string) {
      let retorno = {} as IRetornoRequisicao;
      const statusAntigo = String(pedido.status);
      const index = state.pedidos.findIndex((r) => r.codigo === pedido.codigo);
      desmarcarPedidoSelecionado(state.pedidos[index].codigo, state.pedidos[index].status, Number(novaEtapa));
      retorno = await servicoPedidoCompra.alterarEtapa(pedido.codigo, pedido.codigoEmpresa, Number(novaEtapa));
      if (retorno.status === 1) {
        state.pedidos[index].status = Number(novaEtapa);
      } else if (retorno.status === 2) {
        apresentarMensagemAlerta(retorno.mensagem);
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
      if (state.visualizarKanban) {
        recriarColuna(novaEtapa);
        recriarColuna(statusAntigo);
      } else {
        buscarPedido();
      }
    }

    async function alterarEtapaVarios(pedidos: IDTOPedidoCompra[], proximaEtapa: boolean, cancelamento: boolean) {
      let retorno = {} as IRetornoRequisicao;
      const colunasAlteradas = [] as string[];
      const codigosPedidos = [] as number[];

      pedidos.forEach((pedido) => {
        let novaEtapa = 0;

        if (cancelamento) {
          novaEtapa = 7;
        } else if (proximaEtapa) {
          novaEtapa = pedido.status + 1;
        } else {
          novaEtapa = pedido.status - 1;
        }

        if (!colunasAlteradas.some((c) => c === String(pedido.status))) {
          colunasAlteradas.push(String(pedido.status));
        }
        if (!colunasAlteradas.some((c) => c === String(novaEtapa))) {
          colunasAlteradas.push(String(novaEtapa));
        }
        desmarcarPedidoSelecionado(pedido.codigo, pedido.status, Number(novaEtapa));
        codigosPedidos.push(pedido.codigo);
      });
      retorno = await servicoPedidoCompra.alterarEtapaVarios(state.empresaSelecionada, proximaEtapa, cancelamento, codigosPedidos);
      if (retorno.status === 1) {
        state.pedidos.forEach((r, index) => {
          if (cancelamento) {
            state.pedidos[index].status = 5;
          } else if (proximaEtapa) {
            state.pedidos[index].status += 1;
          } else {
            state.pedidos[index].status -= 1;
          }
        });
      } else if (retorno.status === 2) {
        apresentarMensagemAlerta(retorno.mensagem);
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
      if (state.visualizarKanban) {
        colunasAlteradas.forEach((c) => {
          recriarColuna(c);
        });
      } else {
        buscarPedido();
      }
    }

    async function moverCard(card: ICardKanban, identificadorNovaColuna: string) {
      state.cardSelecionado = card.identificador;
      const indexPedido = state.pedidos.findIndex((r) => r.codigo === Number(state.cardSelecionado));
      const pedido = state.pedidos[indexPedido];
      if (pedido.status === EStatusPedidoCompra.Cancelado) {
        apresentarMensagemAlerta('O Pedido de compra informado está cancelado.');
        recriarColuna(identificadorNovaColuna);
        recriarColuna(String(pedido.status));
        return;
      }
      Modal.confirm({
        title: `Realmente deseja passar da etapa ${obterTituloColuna(String(pedido.status))} para a etapa ${obterTituloColuna(identificadorNovaColuna)}?`,
        content: `Pedido de compra ${pedido.numeroPedido}`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          await alterarEtapa(pedido, identificadorNovaColuna);
        },
        onCancel: () => {
          recriarColuna(identificadorNovaColuna);
          recriarColuna(String(pedido.status));
        },
      });
    }

    async function concluirEtapa() {
      let pedido = {} as IDTOPedidoCompra;
      let titulo = '';
      let mensagem = '';

      if (state.qtdSelecionadosConcluir === 0) {
        apresentarMensagemAlerta('Nenhum pedido selecionado para conclusão de etapa.');
        return;
      } if (state.qtdSelecionadosConcluir === 1) {
        state.selecionados.forEach((s) => {
          const index = state.pedidos.findIndex((r) => r.codigo === s);
          if (state.pedidos[index].status < 5) {
            pedido = state.pedidos[index];
          }
        });
        titulo = `Realmente deseja passar da etapa ${obterTituloColuna(String(pedido.status))} para a etapa ${obterTituloColuna(String(pedido.status + 1))}?`;
        mensagem = `Pedido de compra ${pedido.numeroPedido}.`;
      } else {
        titulo = `Realmente deseja alterar a etapa dos ${state.qtdSelecionadosConcluir} pedidos de compra selecionados?`;
        mensagem = '';
      }

      Modal.confirm({
        title: titulo,
        content: mensagem,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          if (state.qtdSelecionadosConcluir === 1) {
            await alterarEtapa(pedido, String(pedido.status + 1));
          } else {
            const pedidos = [] as IDTOPedidoCompra[];
            state.selecionados.forEach((s) => {
              const indexoPedido = state.pedidos.findIndex((r) => r.codigo === Number(s));
              if (state.pedidos[indexoPedido].status < 5) {
                pedidos.push(state.pedidos[indexoPedido]);
              }
            });
            await alterarEtapaVarios(pedidos, true, false);
          }
        },
      });
    }

    async function retornarEtapa() {
      let pedido = {} as IDTOPedidoCompra;
      let titulo = '';
      let mensagem = '';

      if (state.qtdSelecionadosRetomar === 0) {
        apresentarMensagemAlerta('Nenhum pedido selecionado para retornar a etapa.');
        return;
      } if (state.qtdSelecionadosRetomar === 1) {
        state.selecionados.forEach((s) => {
          const index = state.pedidos.findIndex((r) => r.codigo === s);
          if (state.pedidos[index].status > 1 && state.pedidos[index].status < 6) {
            pedido = state.pedidos[index];
          }
        });
        titulo = `Realmente deseja passar da etapa ${obterTituloColuna(String(pedido.status))} para a etapa ${obterTituloColuna(String(pedido.status - 1))}?`;
        mensagem = `Pedido ${pedido.numeroPedido}.`;
      } else {
        titulo = `Realmente deseja alterar a etapa dos ${state.qtdSelecionadosConcluir} pedidos de compra selecionados?`;
        mensagem = '';
      }

      Modal.confirm({
        title: titulo,
        content: mensagem,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          if (state.qtdSelecionadosRetomar === 1) {
            await alterarEtapa(pedido, String(pedido.status - 1));
          } else {
            const pedidos = [] as IDTOPedidoCompra[];
            state.selecionados.forEach((s) => {
              const indexPedido = state.pedidos.findIndex((r) => r.codigo === Number(s));
              if (state.pedidos[indexPedido].status > 1 && state.pedidos[indexPedido].status < 6) {
                pedidos.push(state.pedidos[indexPedido]);
              }
            });
            await alterarEtapaVarios(pedidos, false, false);
          }
        },
      });
    }

    async function cancelar() {
      let pedido = {} as IDTOPedidoCompra;
      let titulo = '';
      let mensagem = '';

      if (state.qtdSelecionadosCancelar === 0) {
        apresentarMensagemAlerta('Nenhum pedido selecionado para o cancelamento.');
        return;
      } if (state.qtdSelecionadosCancelar === 1) {
        state.selecionados.forEach((s) => {
          const index = state.pedidos.findIndex((r) => r.codigo === s);
          if (state.pedidos[index].status < 6) {
            pedido = state.pedidos[index];
          }
        });
        titulo = 'Realmente deseja cancelar o pedido de compra?';
        mensagem = `Pedido de compra ${pedido.numeroPedido}.`;
      } else {
        titulo = `Realmente deseja cancelar os ${state.qtdSelecionadosConcluir} pedidos de compra selecionados?`;
        mensagem = '';
      }

      Modal.confirm({
        title: titulo,
        content: mensagem,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          if (state.qtdSelecionadosCancelar === 1) {
            await alterarEtapa(pedido, '7');
          } else {
            const pedidos = [] as IDTOPedidoCompra[];
            state.selecionados.forEach((s) => {
              const indexPedidos = state.pedidos.findIndex((r) => r.codigo === Number(s));
              if (state.pedidos[indexPedidos].status < 5) {
                pedidos.push(state.pedidos[indexPedidos]);
              }
            });
            await alterarEtapaVarios(pedidos, false, true);
          }
        },
      });
    }

    async function excluirPedidos(pedidos: IDTOPedidoCompra[]) {
      const colunasAlteradas = [] as string[];
      const codigosPedidos = [] as number[];

      pedidos.forEach((pedido) => {
        desmarcarPedidoSelecionado(pedido.codigo, pedido.status, pedido.status);
        if (!colunasAlteradas.some((c) => c === String(pedido.status))) {
          colunasAlteradas.push(String(pedido.status));
        }
        codigosPedidos.push(pedido.codigo);
      });

      const retorno = await servicoPedidoCompra.excluirVarios(state.empresaSelecionada, codigosPedidos);
      if (retorno.status === 1) {
        pedidos.forEach((pedido) => {
          const indexPedido = state.pedidos.findIndex((r) => r.codigo === pedido.codigo);
          state.pedidos.splice(indexPedido, 1);
        });
        colunasAlteradas.forEach((c) => {
          recriarColuna(c);
        });
        apresentarMensagemSucesso(retorno.mensagem);
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
    }

    async function excluir() {
      const pedidos = [] as IDTOPedidoCompra[];
      let pedido = {} as IDTOPedidoCompra;
      let titulo = '';
      let mensagem = '';

      if (state.qtdSelecionadosExcluir === 0) {
        apresentarMensagemAlerta('Nenhum pedido de compra selecionado para exclusão.');
        return;
      } if (state.qtdSelecionadosExcluir === 1) {
        state.selecionados.forEach((s) => {
          const index = state.pedidos.findIndex((r) => r.codigo === s);
          if (state.pedidos[index].status === 1) {
            pedido = state.pedidos[index];
          }
        });
        titulo = 'Realmente deseja excluir o pedido de compra?';
        mensagem = `Pedido de compra ${pedido.numeroPedido}.`;
      } else {
        titulo = `Realmente deseja excluir os ${state.qtdSelecionadosExcluir} pedidos de compra selecionados?`;
        mensagem = '';
      }

      Modal.confirm({
        title: titulo,
        content: mensagem,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          if (state.qtdSelecionadosExcluir === 1) {
            pedidos.push(pedido);
            await excluirPedidos(pedidos);
          } else {
            state.selecionados.forEach((s) => {
              const indexPedido = state.pedidos.findIndex((r) => r.codigo === Number(s));
              if (state.pedidos[indexPedido].status === 1) {
                pedidos.push(state.pedidos[indexPedido]);
              }
            });
            await excluirPedidos(pedidos);
          }
        },
      });
    }

    async function imprimirDetalhado(codgo: number) {
      telaBase.carregando = true;
      const retornoRelatorio = await servicoPedidoCompra.ImprimirPedidoCompra(codgo, state.empresaSelecionada, ETipoArquivo.PDF);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function imprimirListagem(codigos: number[]) {
      const parametrosConsulta = {} as IParametrosConsultaRecebimentoMercadoria;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.numeroPagina = 1;
      parametrosConsulta.qtdeRegistrosPagina = 0;
      parametrosConsulta.qtdeRegistrosTotal = 0;
      parametrosConsulta.periodo = state.filtroPeriodo;
      parametrosConsulta.dataInicial = state.dataInicialSelecionada;
      parametrosConsulta.dataFinal = state.dataFinalSelecionada;
      parametrosConsulta.ordenacao = Array<string>();
      parametrosConsulta.ordenacao.push('Status', 'Ordem');

      telaBase.carregando = true;
      const retornoRelatorio = await servicoPedidoCompra.relatorioPadrao(ETipoArquivo.PDF, parametrosConsulta, state.filtros, codigos);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function imprimir() {
      if (state.selecionados.length === 0) {
        apresentarMensagemAlerta('Nenhum pedido de compra selecionado para impressão!');
      } else if (state.selecionados.length === 1) {
        imprimirDetalhado(state.selecionados[0]);
      } else {
        imprimirListagem(state.selecionados);
      }
    }

    onBeforeMount(async () => {
      state.visualizarKanban = !UtilitarioDispositivo.larguraTelaMobile();
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      telaBase.identificadorRecurso = state.identificadorRecurso;
      telaBase.identificadorPermissao = state.identificadorPermissao;
      preencherColunas();
      await obterPermissoes(ETipoPermissao.Dados);
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas([state.empresaSelecionada]);
      telaBase.propriedadesConsulta = await servicoPedidoCompra.obterPropriedadesConsulta();
      if (telaBase.propriedadesConsulta.length > 0) {
        state.buscaAvancada.filtros = telaBase.propriedadesConsulta.filter((item) => item.filtro === true);
        state.buscaAvancada.ordenacao = telaBase.propriedadesConsulta.filter((item) => item.ordenacao === true);
      }
      state.buscaAvancada.filtrosAdicionados = [];
      state.buscaAvancada.chaveFiltrosAdicionados = 0;
      state.dataAtual = await new ServicoSistema().obterDataAtual();
      await buscarPedido();
    });

    function buscaRapidaPedido() {
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        await buscarPedido();
      }, 600);
    }

    async function periodoAlterado() {
      if (state.filtroPeriodo !== EFiltroPeriodoMovimentoComercial.Personalizado) {
        await buscarPedido();
      }
    }
    return {
      state,
      props,
      window,
      EVinculoEmpresa,
      EFiltroPeriodoMovimentoComercial,
      UtilitarioMascara,
      UtilitarioData,
      storeSistema,
      telaBase,
      buscaRapidaPedido,
      incluir,
      editarPedido,
      clickEditar,
      excluir,
      retornarEtapa,
      buscarPedido,
      atualizarSelecaoEmpresas,
      adicionarAtalho,
      removerAtalho,
      selecionarCard,
      concluirEtapa,
      moverCard,
      atualizarSelecionados,
      atualizarOrdemCards,
      atualizarSelecionadosKanban,
      cancelar,
      imprimirDetalhado,
      imprimir,
      periodoAlterado,
    };
  },
});
